<div class="action-column-container">
	@for (actionType of column.customData.actions; track actionType) {
		@if (actionType === ACTION_TYPES.OPEN_IN_DT) {
			<open-dt-from-workspace [entityName]="getEntityName(data)" [entity]="data" />
		} @else {
			<button
				mat-icon-button
				class="au-button-no-shadow"
				(click)="$event.stopPropagation(); actionHandler($event, actionType)"
			>
				<mat-icon
					[class]="getColorActionIcon(actionType)"
					[svgIcon]="getActionIcon(actionType)"
				/>
			</button>
		}
	}
</div>
